module.exports = __webpack_public_path__ + "img/activity_dec_title.9f8e32eb.png";